import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ClientRoute({ children }) {
    const { user } = useAuth();

    if (user === null) {
        return (
            <div className="flex h-screen items-center justify-center bg-zinc-50">
                <div className="h-6 w-6 animate-spin rounded-full border-2 border-zinc-300 border-t-[#FF3B30]" />
            </div>
        );
    }

    if (!user) return <Navigate to="/entrar" replace />;
    if (user.role !== "cliente") return <Navigate to="/dashboard" replace />;
    if (user.is_approved === false) return <Navigate to="/entrar" replace />;

    return children;
}
